import { normalize } from 'normalizr'

import { googleLocationSchema } from './schemas'
import { countriesFromHost, countryFromHost } from 'shared/country'
import { competitors } from './constants'

export const fetchPlaces = input =>
    new Promise((resolve, reject) => {
        const autocompleteService = new google.maps.places.AutocompleteService()
        const OK = google.maps.places.PlacesServiceStatus.OK
        const options = {
            input,
            types: countryFromHost() === 'ca' ? undefined : ['geocode'],
            componentRestrictions: {
                country: countriesFromHost()
                    .toLowerCase()
                    .split(','),
            },
        }

        autocompleteService.getPlacePredictions(options, (predictions, status) => {
            if (status !== OK) reject()

            return resolve({ predictions, status })
        })
    })

export const fetchGooglePlaces = async input => {
    const { predictions } = await fetchPlaces(input)

    // Removes autocomplete results that include matching keywords from the competitors array
    const filteredPredictions = predictions.filter(
        ({ description }) =>
            !competitors.some(competitor => description.toLowerCase().includes(competitor.toLowerCase()))
    )

    return normalize(filteredPredictions, [googleLocationSchema])
}

export const getGoogleLocationGeocodeById = placeId => geocodeByPlaceId(placeId)

export const geocodeByPlaceId = placeId =>
    new Promise((resolve, reject) => {
        const geocoder = new google.maps.Geocoder()
        const OK = google.maps.GeocoderStatus.OK

        geocoder.geocode({ placeId }, (results, status) => {
            if (status !== OK) reject()

            resolve({
                x: results[0].geometry.location.lat(),
                y: results[0].geometry.location.lng(),
            })
        })
    })
